import type { Quality } from './post';

/**
 * The current render quality tier, published by the render system each frame, for views that thin
 * their own detail by tier without a game context (the city view's clutter and kerb stones, see
 * docs/PERF.md "Phone performance"). Listeners run on subscribe and on every change.
 */
let tier: Quality = 'high';
let published = false;
const listeners = new Set<(q: Quality) => void>();
const firstListeners: (() => void)[] = [];

export function qualityTier(): Quality {
  return tier;
}

/** Render system only. */
export function publishQualityTier(q: Quality): void {
  if (q !== tier) {
    tier = q;
    for (const fn of [...listeners]) fn(q);
  }
  if (!published) {
    published = true;
    for (const fn of firstListeners.splice(0)) fn();
  }
}

export function onQualityTier(fn: (q: Quality) => void): () => void {
  listeners.add(fn);
  fn(tier);
  return () => void listeners.delete(fn);
}

/**
 * Run `fn` once the render system has published its first tier (now, if it has). Until then the tier is a
 * default ('high'), not the device's: a download only one tier wants (the HIGH facade relief) waits for this
 * on phones, which start at MEDIUM.
 */
export function onQualityTierKnown(fn: () => void): void {
  if (published) fn();
  else firstListeners.push(fn);
}
